/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
define([
    'lodash',
    'reactDOM',
    'componentsCore',
    'core/components/siteAspects/timelineAspect/model',
    'core/components/siteAspects/timelineAspect/functionLibrary'
], function (
    _,
    ReactDOM,
    componentsCore,
    Model,
    functionLibrary
) {
    'use strict';

    const name = 'TimelineAspect';
    const {
        queueActions: {ADD, PLAY, PLAY_REVERSE, PAUSE, CLEAR, SEEK, EVENT_ADD, EVENT_REMOVE},
        addActionToQueue,
        addCreateActionToQueue,
        removeTimeline,
        createTimeline,
        addToTimeline,
        playTimeline,
        playReverseTimeline,
        pauseTimeline,
        seekTimeline,
        clearTimeline,
        addEventCallback,
        removeEventCallback
    } = functionLibrary;

    function getElement(compId, aspectSiteAPI) {
        const pageId = aspectSiteAPI.getRootOfComponentId(compId);
        const component = aspectSiteAPI.getComponentByPageAndCompId(pageId, compId);
        return component ? ReactDOM.findDOMNode(component) : null;
    }

    function getElementsToAnimate(compIds, aspectSiteAPI) {
        return _(compIds).map(compId => getElement(compId, aspectSiteAPI)).compact().value();
    }

    function processQueueItems(items, model, animator, aspectSiteAPI) {
        // eslint-disable-next-line complexity
        _.map(items, ({action, data = {}, resolve, reject, id}) => {
            const sequence = model.getTimelineSequence(id);

            const compIds = data.compIds;
            const elements = getElementsToAnimate(compIds, aspectSiteAPI);

            switch (action) {
                case ADD: return addToTimeline(model, animator, sequence, elements, id, data, resolve, reject);
                case PLAY: return playTimeline(sequence, resolve, reject);
                case PLAY_REVERSE: return playReverseTimeline(sequence, resolve, reject);
                case PAUSE: return pauseTimeline(sequence, resolve, reject);
                case CLEAR: return clearTimeline(model, sequence, id, resolve, reject);
                case SEEK: return seekTimeline(sequence, data.progress, resolve, reject);
                case EVENT_ADD: return addEventCallback(sequence, data, resolve, reject);
                case EVENT_REMOVE: return removeEventCallback(sequence, data, resolve, reject);
            }
        });
    }

    function flushQueue(aspectSiteAPI, model, animator, isAnimationsEnabled, pageReady) {
        const queues = model.getQueues();

        if (isAnimationsEnabled && pageReady) {
            _.forEach(queues,
                (queue = {}, id) => {
                    // Run through all queues by timeline id
                    const items = queue.items;
                    // Get timeline creation data if exists
                    const createItem = queue.createItem;

                    if (createItem) {
                        createTimeline(model, id, animator, createItem);
                        return;
                    }
                    if (items) {
                        processQueueItems(items, model, animator, aspectSiteAPI);
                        model.setTimelineQueue(id);
                    }
                }
            );
        }
    }

    function removeTimelines(aspectSiteAPI, model, animator, isAnimationsEnabled, pageReady) {
        const timelines = model.getTimelines();

        _.forEach(timelines, (value = {}, id) => {
            const compIds = value.compIds || [];
            const sequence = value.sequence;
            if (!sequence) {
                return;
            }
            const elements = getElementsToAnimate(compIds, aspectSiteAPI);
            if (!isAnimationsEnabled || !pageReady || (compIds.length && !elements.length)) {
                removeTimeline(model, id, animator, sequence, elements);
            }
        });
    }

    // "privates"
    function handleModelUpdates(model, aspectSiteAPI) {
        const siteData = aspectSiteAPI.getSiteData();

        const pageId = siteData.getCurrentUrlPageId();
        const modelPageId = model.getPageId();
        const animator = siteData.animations;
        const isAnimationsEnabled = aspectSiteAPI.getRenderFlag('componentViewMode') === 'preview';
        const isMobileView = siteData.isMobileView();
        const modelMobileView = model.getIsMobileView();
        const pageReady = pageId === modelPageId && isMobileView === modelMobileView; // TODO: be more precise

        flushQueue(aspectSiteAPI, model, animator, isAnimationsEnabled, pageReady);
        removeTimelines(aspectSiteAPI, model, animator, isAnimationsEnabled, pageReady);

        if (isMobileView !== modelMobileView) {
            model.setIsMobileView(isMobileView);
        }

        if (pageId !== modelPageId) {
            aspectSiteAPI.registerNavigationComplete(() => model.setPageId(pageId));
        }
    }

    function TimelineAspect(aspectSiteAPI) {
        this._aspectSiteAPI = aspectSiteAPI;
        const siteData = aspectSiteAPI.getSiteData();

        //this.aspectSiteAPI.setAspectGlobalData('TimelineAspect', {});
        this.model = new Model();

        this.model.setPageId(siteData.getCurrentUrlPageId());
        this.model.setUpdateCallback(() => handleModelUpdates(this.model, this._aspectSiteAPI));

        this._initiated = false;
    }

    TimelineAspect.prototype = {
        createTimeline(id, data) {
            if (!this._initiated) {
                this._aspectSiteAPI.registerToDidLayout(this.model.triggerImmediateUpdate);
                this._initiated = true;
            }
            return addCreateActionToQueue(this.model, id, data);
        },
        addToTimeline(id, data) {
            return addActionToQueue(this.model, id, ADD, data);
        },
        clearTimeline(id) {
            return addActionToQueue(this.model, id, CLEAR);
        },
        playTimeline(id) {
            return addActionToQueue(this.model, id, PLAY);
        },
        playReverseTimeline(id) {
            return addActionToQueue(this.model, id, PLAY_REVERSE);
        },
        pauseTimeline(id) {
            return addActionToQueue(this.model, id, PAUSE);
        },
        seekTimeline(id, progress) {
            return addActionToQueue(this.model, id, SEEK, {progress});
        },
        addTimelineEvent(id, eventName, handler) {
            return addActionToQueue(this.model, id, EVENT_ADD, {eventName, handler});
        },
        removeTimelineEvent(id, eventName) {
            return addActionToQueue(this.model, id, EVENT_REMOVE, {eventName});
        }
    };

    componentsCore.siteAspectsRegistry.registerSiteAspect(name, TimelineAspect);

    return TimelineAspect;
});
